import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// Search schema for tab deep-linking. Used by callers that want to land the
// user on a specific tab — e.g. the post-key-creation nav link from the
// sources list, which sends people to /app/sources/{id}?tab=settings so they
// can see where their key now lives.
const searchSchema = z.object({
  tab: z.enum(["routes", "settings"]).optional(),
});

// Route metadata only. Component lives in `$sourceId.lazy.tsx`.
export const Route = createFileRoute("/app/sources/$sourceId")({
  validateSearch: searchSchema,
});
